export default class StripeEvent {
  static generateEmpty() {
    return {
      id: null,
      order_id: null,
      stripe_charge_id: '',
      amount_charged: 0.0,
      app_fee: 0.0,
      processing_fee: 0.0,
      status: '',
      _jv: {
        type: 'StripeEvent',
      }
    }
  };
}